import { z } from "zod";
import { TovMapEnqueueOutcomeSchema } from "../../enums/tov-mapping";
import { TovChunkResponseSchema } from "./evidence.responses";

export const TovMapEnqueueResponseSchema = z.object({
  ok: z.literal(true),
  // `coalesced` = a mapping run for this Version is already in flight, so no
  // second run was queued (duplicate LLM spend guard). `resumed` = the latest
  // failed attempt was republished so its durable checkpoints are reused
  // instead of re-extracting every page/group.
  outcome: TovMapEnqueueOutcomeSchema,
});
export type TovMapEnqueueResponse = z.infer<typeof TovMapEnqueueResponseSchema>;

export const TovEvidenceVectorSearchResultSchema =
  TovChunkResponseSchema.extend({
    distance: z.number(),
  });
export type TovEvidenceVectorSearchResult = z.infer<
  typeof TovEvidenceVectorSearchResultSchema
>;

export const TovEvidenceVectorSearchResponseSchema = z.object({
  chunks: z.array(TovEvidenceVectorSearchResultSchema),
});
export type TovEvidenceVectorSearchResponse = z.infer<
  typeof TovEvidenceVectorSearchResponseSchema
>;
